export const CURRENT_CONFIG = {

  // license
  appId: '186589', // You need to go to the development website to apply.
  appKey: '560d06f0c5b2ae0de518fdd9332e43a', // You need to go to the development website to apply.
  appLicense: 'qzWJ8Fj2vUhiJtDLWaZfL3ZrNWwxpr/PH6KJMM4ZoFxsK8AcMVTHuMiDj8fDvpFq+jwg88UAYXHNryadBi1Za+Q2da5lWq5V3/RxUpqBl196U/NIJZMno5aIVintoMhsf6ecJBggrEhQV3qg+cxRZjIu0BHPLifnMrzBiSjD39A=', // You need to go to the development website to apply.

  // http
  baseURL: 'http://47.92.128.178:6789/',
  websocketURL: 'ws://47.92.128.178:6789/api/v1/ws',

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://47.92.128.178:1935/live/',
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  // rtspUserName: 'Please enter the username.',
  // rtspPassword: 'Please enter the password.',
  // rtspPort: '8554',
  // Agora
  // agoraAPPID: 'Please enter the agora app id.',
  // agoraToken: 'Please enter the agora temporary token.',
  // agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'c875d60f2747074a49e6d8835d9abbc2',

}
